<template>
    <ion-page>
        <ion-loading :is-open="loading" message="Loading, please wait"/>
        <standard-header :title="title" align="middle"/>
        <ion-content class="ion-padding">
            <ion-segment v-model="segment">
                <ion-segment-button value="amazon">Amazon</ion-segment-button>
                <ion-segment-button value="customer">Customer</ion-segment-button>
            </ion-segment>
            <div v-show="segment === 'amazon'">
                <ion-list>
                    <ion-item lines="none">
                        <ion-label>
                            <ion-searchbar v-model="searchText" @keypress.enter="doSearch()" animated mode="ios" />
                        </ion-label>
                        <ion-button size="medium" color="primary" @click="openScanner()">
                            <ion-icon slot="icon-only" :icon="barcode"/>
                        </ion-button>
                    </ion-item>
                    <ion-item v-if="! (results && results.length > 0)">
                        <ion-label>No results found</ion-label>
                    </ion-item>
                    <ion-item button v-for="item in results" :key="item.id" :detail="true" @click="select(item)">
                        <ion-label class="ion-margin-start">
                            <h2>{{ item.amazon_uplift.amazon_reference }}</h2>
                            <p>
                                {{item.qty_requested}} x {{ item.description }}<br />
                                {{ item.sku }} / {{item.asin}}
                            </p>
                        </ion-label>
                    </ion-item>
                </ion-list>
            </div>
            <div v-show="segment === 'customer'">
                <ion-list>
                    <ion-item lines="none">
                        <ion-label class="ion-text-wrap" v-if="hasScannedItem">
                            <h2>{{ scannedItem.name }}</h2>
                            <p>{{ scannedItem.item_number }}</p>
                        </ion-label>
                        <ion-label v-else>
                            <h2>Scan or search for item</h2>
                        </ion-label>
                        <ion-button size="medium" color="primary" @click="openItemScanner()">
                            <ion-icon slot="icon-only" :icon="barcode"/>
                        </ion-button>
                        <ion-button expand="block" color="primary" size="medium" @click="openItemPicker()">
                            <ion-icon slot="icon-only" :icon="search"/>
                        </ion-button>
                    </ion-item>
                </ion-list>
            </div>
        </ion-content>
        <ion-footer v-show="segment === 'customer'" >
            <ion-button :disabled="!hasScannedItem" color="warning" class="ion-margin-top" size="large" expand="full" @click="startCustomerReturn()">
                Next
            </ion-button>
        </ion-footer>
    </ion-page>
</template>

<script>
import {
    IonPage,
    IonSearchbar,
    IonContent,
    IonLabel,
    IonItem,
    IonLoading, IonIcon, IonButton, alertController,
    IonFooter,
    IonSegment,
    IonSegmentButton,
    IonList
} from "@ionic/vue";
import StandardHeader from "../../../../components/StandardHeader";
import {barcode, checkmarkCircle, listOutline, search} from "ionicons/icons";
import {Capacitor} from "@capacitor/core";
import ItemSearchModalHelper from "@/services/ItemSearchModalHelper";

export default {
    name: "List.vue",
    components: {
        IonPage,
        StandardHeader,
        IonContent,
        IonItem,
        IonLabel,
        IonLoading,
        IonIcon,
        IonButton,
        IonSearchbar,
        IonSegment,
        IonFooter,
        IonSegmentButton,
        IonList
    },
    inject: ['$http', '$scanner'],
    computed: {
        title() {
            if (this.segment == 'amazon') {
                return 'Choose Amazon Uplift';
            }
            return 'Scan Returned Item';
        },
        include(){
            return 'amazon_uplift,skus'
        },
        hasScannedItem() {
            return this.scannedItem && this.scannedItem.id > 0;
        },
    },
    watch: {
        scannedItem(val) {
            if(val.skus && val.skus[0].id) {
                this.doSearch(val.skus[0].barcode);
            }
        }
    },
    ionViewDidEnter() {
        this.scannedItem = {};
    },
    methods: {
        /**
         * For customer returns only
         */
        openItemScanner() {
            if (Capacitor.platform === 'web') {
                alert("This requires a scanner");
                return;
            }
            this.$scanner.search().then(result => {
                this.scannedItem = result;
            });
        },
        /**
         * For customer returns only
         */
        openItemPicker() {
            ItemSearchModalHelper.open().then(item => {
                this.scannedItem = item.data;
            });
        },
        doSearch() {
            this.loading = true;
            this.$http
                .get('/api/uplift-lines', {params: { search: this.searchText, include: this.include }})
                .then(response => {
                    this.results = response.data.items;
                    this.loading = false;
                }).catch(() => {
                this.loading = false;
            });
        },
        startCustomerReturn() {
            this.$router.push({
                name: 'warehouse.uplifts.update', params: {
                    upliftItemName: this.scannedItem.name,
                    scannedItemId: this.scannedItem.id
                },
                query: {
                    skip_uplifts: true
                }
            });
        },
        select(item) {
            this.$router.push({
                name: 'warehouse.uplifts.show', params: {
                    upliftLineId: item.id,
                    upliftItemSku: item.sku,
                }})
        },
        async openScanner() {
            if (Capacitor.platform === 'web') {
                const alert = await alertController.create({
                    header: 'Enter Returns Barcode',
                    inputs: [{
                        type: 'number',
                        name: 'barcode'
                    }],
                    buttons: ['Ok']
                });
                alert.onDidDismiss().then(input => {
                    this.searchText = input.data.values.barcode;
                    this.doSearch();
                });
                alert.present();
                return;
            }
            this.$scanner.scan().then(result => {
                this.searchText = result.barcode;
                this.$nextTick(() => {
                    this.doSearch();
                });
                // search for uplift lines
            }).catch(error => {
                this.searchText = '';
                this.$toast.danger(error);
            });
        },
    },
    data(){
        return {
            segment: 'amazon',
            results: [],
            qts: '',
            loading: false,
            scannedItem: {},
            searchText: ''
        }
    },
    setup() {
        return {
            checkmarkCircle, search, barcode, listOutline
        }
    }
}
</script>

<style scoped>

</style>